module.exports = __webpack_public_path__ + "img/siam_logo.351fddee.png";